import React, { Component } from 'react';
import RegExpHelper from '../../../../../Common/Helpers/RegExpHelper';
import InputDefecto from '../../../../../Common/Components/InputDefecto';
import ExpHelper from '../../../../../Common/Helpers/ExpHelper';
import CheckDefecto from '../../../../../Common/Components/CheckDefecto';

class LimiteFinanciacionCabal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            limiteFinanciacionCabalMin: props.data.limiteFinanciacionCabalMin,
            limiteFinanciacionCabalMax: props.data.limiteFinanciacionCabalMax,
            limiteFinanciacionCabalDefault: props.data.limiteFinanciacionCabalDefault
        };
    }

    onLimiteFinanciacionCabalChange(event) {
        const { value, dataset } = event.target;
        const regExp = new RegExp(dataset.validation);
        /*Antes de actualizar cualquier cosa, valido que se haya presionado el boton*/
        //if (this.props.data.LimiteCompraCabal) {
        if (regExp.test(value) || value.replace(/\s/g, "", "") == "") {
            let newState = {
                [dataset.code]: value
            }

            if (dataset.code == "limiteFinanciacionCabalMin") {
                newState = {
                    ...newState,
                    limiteFinanciacionCabalDefault: value
                }
            }

            this.setState(newState);
        }
        //}


    }

    onLimiteFinanciacionCabalBlur(event) {
        const { value, dataset } = event.target;
        this.props.changeInput(dataset.code, value);
        if (dataset.code == "limiteFinanciacionCabalMin") {
            this.props.changeInput("limiteFinanciacionCabalDefault", value);
        }
    }

    componentWillReceiveProps(nextProps) {
        this.state = {
            limiteFinanciacionCabalMin: nextProps.data.limiteFinanciacionCabalMin,
            limiteFinanciacionCabalMax: nextProps.data.limiteFinanciacionCabalMax,
            limiteFinanciacionCabalDefault: nextProps.data.limiteFinanciacionCabalDefault
        };
    }

 
    render() {
        const { onLimiteFinanciacionCabalChange, onLimiteFinanciacionCabalBlur } = this;
        let { data, form, changeInput, selectCheckBox } = this.props;
 
        let acentoLetraAminuscula = ExpHelper.ConvertirCaracter("a");
        let acentoLetraIminuscula = ExpHelper.ConvertirCaracter("i");
        let acentoLetraOminuscula = ExpHelper.ConvertirCaracter("o");

        let errorLimites
        let errorLimiteDefault

        if(this.state.limiteFinanciacionCabalMin != "" && this.state.limiteFinanciacionCabalMax != "" && this.state.limiteFinanciacionCabalDefault != ""){
            errorLimites =  !(parseInt(this.state.limiteFinanciacionCabalMin) <= parseInt(this.state.limiteFinanciacionCabalMax)) 
            if(!errorLimites){
                errorLimiteDefault = !(parseInt(this.state.limiteFinanciacionCabalDefault) >= parseInt(this.state.limiteFinanciacionCabalMin) && parseInt(this.state.limiteFinanciacionCabalDefault) <= parseInt(this.state.limiteFinanciacionCabalMax))
            }
        }
        
        return (
            <div className="row top-separator-xs">
                <div className="col-xs-12">
                    <label className="label-primary">{"L" + acentoLetraIminuscula + "mite de Financiaci" + acentoLetraOminuscula + "n"}</label>
                    <div className="container-radio radio-margin">
                        <div className="row">
                            <div className="col-xs-2"><label className="lbl-radio label-secondary">{"M" + acentoLetraIminuscula + "nimo"}</label></div>

                            <div className="col-xs-2">
                                <input className="form-control"
                                    maxLength={9}
                                    value={this.state.limiteFinanciacionCabalMin}
                                    data-code="limiteFinanciacionCabalMin"
                                    data-validation="^[0-9]*$"
                                    onChange={onLimiteFinanciacionCabalChange.bind(this)}
                                    onBlur={onLimiteFinanciacionCabalBlur.bind(this)}
                                />
                            </div>
                            
                            <div className="col-xs-2"><label className="lbl-radio label-secondary">{"M" + acentoLetraAminuscula + "ximo"}</label></div>

                            <div className="col-xs-2" style={{ position: 'relative', right: '48px' }}>
                                <input className="form-control"
                                    maxLength={9}
                                    value={this.state.limiteFinanciacionCabalMax}
                                    data-code="limiteFinanciacionCabalMax"
                                    data-validation="^[0-9]*$"
                                    onChange={onLimiteFinanciacionCabalChange.bind(this)}
                                    onBlur={onLimiteFinanciacionCabalBlur.bind(this)}
                                />
                            </div>                           

                        </div>
                        <div className="row">
                            <div className="col-xs-2"><label className="lbl-radio label-secondary">{"L" + acentoLetraIminuscula + "mite de Financiaci" + acentoLetraOminuscula + "n por defecto"}</label></div>

                            <div className="col-xs-2">
                                <input className="form-control"
                                    maxLength={9}
                                    value={this.state.limiteFinanciacionCabalDefault}
                                    data-code="limiteFinanciacionCabalDefault"
                                    data-validation="^[0-9]*$"
                                    onChange={onLimiteFinanciacionCabalChange.bind(this)}
                                    onBlur={onLimiteFinanciacionCabalBlur.bind(this)}
                                />
                            </div>
                        </div>
                        <div className="lbl-radio">
                            
                        <CheckDefecto referencia={"limiteFinanciacionCabalCheck"}
                            check={data.limiteFinanciacionCabalDefaultInterfaz}
                            selectCheckBox={({ target }) => selectCheckBox("limiteFinanciacionCabalDefaultInterfaz", target.checked)}
                            />
                        </div>
                        {(data.ERROR_PRODUCT["limiteFinanciacionCabal"] == false && errorLimites )? <label className="error">El límite inferior debe ser menor o igual al límite superior.</label> : null}
                        {(data.ERROR_PRODUCT["limiteFinanciacionCabal"] == false && errorLimiteDefault )? <label className="error">El valor por defecto debe estar entre el límite inferior y superior.</label> : null}
                        {data.ERROR_PRODUCT["limiteFinanciacionCabal"] == false && !errorLimites && !errorLimiteDefault ? <label className="error">Debe ingresar Límite de Financiación.</label> : null}

                    </div>
                </div>
            </div>
        );
    }
};

export default LimiteFinanciacionCabal;